export const AppStore = function (goodsid, quantity) {
  switch (parseInt(goodsid)) {
    // 高级版
    case 82:
      if (window.localStorage && window.localStorage.getItem('version') >= '3.1.91') {
        return {
          store: 'com.yuanbei.heighVersion_Year',
          id: 4
        }
      } else {
        return quantity === 12 ? {
          store: 'com.yuanbei.gaoji_12_month',
          id: 4
        } : {
          store: 'com.yuanbei.gaoji_month',
          id: 28
        }
      }
    // 手机橱窗
    case 6:
      return quantity === 12 ? {
        store: 'com.yuanbei.chuchuang_year',
        id: 31
      } : {
        store: 'com.yuanbei.chuchuang_month',
        id: 30
      }
    // 手机橱窗
    case 105:
      return quantity === 12 ? {
        store: 'com.yuanbei.chuchuang_year',
        id: 31
      } : {
        store: 'com.yuanbei.chuchuang_month',
        id: 30
      }
    // 微信会员卡
    case 106:
      return quantity === 12 ? {
        store: 'com.yuanbei.weixinhuiyuanka_year',
        id: 33
      } : {
        store: 'com.yuanbei.weixinhuiyuanka_month',
        id: 32
      }
    // 微销宝
    case 107:
      return quantity === 12 ? {
        store: 'com.yuanbei.weixiaobao_year',
        id: 35
      } : {
        store: 'com.yuanbei.weixiaobao_month',
        id: 34
      }
    case 67:
      return {
        store: 'com.yuanbei.tradeEdition_clothing_year',
        id: 36
      }
    case 119: {
      return {
        store: 'com.yuanbei.allLifeGaoji_presell',
        id: 37
      }
    }
    case 120: {
      return {
        store: 'com.yuanbei.allLifeHangye_presell',
        id: 38
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/model/pay/apple-store.js